export type CategoryId = "football" | "basketball" | "esports" | "racing" | "general";

export interface Category {
  id: CategoryId;
  name: string;
  shortName: string;
  icon: string;
  description: string;
  intro: string;
  countLabel: string;
}

export interface VideoItem {
  id: string;
  title: string;
  categoryId: CategoryId;
  cover: string;
  duration: string;
  uploadedAt: string;
  uploader: string;
  views: number;
  episode: string;
  level: string;
  region: string;
  timeRange: string;
  tags: string[];
  description: string;
  notes: string;
}

export const categories: Category[] = [
  {
    id: "football",
    name: "足球黑榜",
    shortName: "足球",
    icon: "ri-football-line",
    description: "足球黑榜 - 全面收录每日足球赛事的精彩黑榜视频",
    intro:
      "从门将脱手、后卫回传到争议判罚，这里收录每日足球赛场上最让人心跳加速的失误瞬间，按时间段、比赛等级与地区分类整理。",
    countLabel: "每日更新",
  },
  {
    id: "basketball",
    name: "篮球黑榜",
    shortName: "篮球",
    icon: "ri-basketball-line",
    description: "篮球黑榜 - 全面收录每日篮球赛事的精彩黑榜视频",
    intro:
      "空篮不进、发球失误、末节崩盘，篮球黑榜把每一场关键回合里的遗憾片段整理成可回看的合集。",
    countLabel: "每日更新",
  },
  {
    id: "esports",
    name: "电竞黑榜",
    shortName: "电竞",
    icon: "ri-gamepad-line",
    description: "电竞黑榜 - 全面收录每日电竞赛事的精彩黑榜视频",
    intro:
      "闪现空放、抢龙失手、指挥失误，电竞黑榜专注复盘每日赛事里最令人沉默的团战与决策瞬间。",
    countLabel: "每日更新",
  },
  {
    id: "racing",
    name: "赛车黑榜",
    shortName: "赛车",
    icon: "ri-roadster-line",
    description: "赛车黑榜 - 全面收录每日赛车赛事的精彩黑榜视频",
    intro:
      "进站失误、轮胎管理翻车、发车连环追尾，赛车黑榜记录赛道上每一次直接把名次送走的操作。",
    countLabel: "每日更新",
  },
  {
    id: "general",
    name: "综合黑榜",
    shortName: "综合",
    icon: "ri-trophy-line",
    description: "综合黑榜 - 全面收录田径、网球等综合赛事的精彩黑榜视频",
    intro:
      "接力掉棒、抢七双误、跳远踩线，综合黑榜收录田径、网球等项目里最不该出现的失误合集。",
    countLabel: "每日更新",
  },
];

export const levelOptions = ["全部等级", "顶级", "职业", "业余"];
export const regionOptions = ["全部地区", "国内", "海外"];
export const timeOptions = ["全部时间", "本周", "本月", "经典"];

export const videos: VideoItem[] = [
  {
    id: "v-101",
    title: "第128期｜门将三连脱手，后卫回传送礼：这支球队的防线怎么了",
    categoryId: "football",
    cover:
      "https://readdy.ai/api/search-image?query=Dramatic%20night%20football%20stadium%20scene%20with%20a%20goalkeeper%20diving%20and%20missing%20the%20ball%2C%20deep%20navy%20shadows%20and%20warm%20amber%20floodlights%2C%20cinematic%20editorial%20sports%20photography%2C%20high%20detail%2C%20moody%20contrast%2C%20clean%20dark%20background&width=640&height=360&seq=bl-101&orientation=landscape",
    duration: "08:42",
    uploadedAt: "2026-10-17",
    uploader: "黑榜观察员·老白",
    views: 48213,
    episode: "第128期",
    level: "顶级",
    region: "国内",
    timeRange: "本周",
    tags: ["门将失误", "防线崩盘", "补时阶段"],
    description:
      "本期足球黑榜聚焦一支连续三轮不胜的球队：门将三次脱手、后卫一次毫无必要的回传，直接把比赛送进对手手里。",
    notes:
      "三次失球分别发生在上半场第 31 分钟、下半场第 64 分钟与补时第 2 分钟。前两次属于典型的站位判断问题，第三次则是后场沟通缺失导致的回传失误。我们把三个机位的画面按时间轴剪在一起，方便对比门将的移动路线。",
  },
  {
    id: "v-102",
    title: "补时绝杀变乌龙：一脚解围踢进自家球门，全场沉默",
    categoryId: "football",
    cover:
      "https://readdy.ai/api/search-image?query=Football%20defender%20sliding%20to%20clear%20the%20ball%20near%20his%20own%20goal%20under%20bright%20floodlights%2C%20dark%20navy%20night%20atmosphere%20with%20amber%20light%20streaks%2C%20cinematic%20sports%20photography%2C%20sharp%20detail%2C%20moody%20editorial%20style%2C%20empty%20dark%20background&width=640&height=360&seq=bl-102&orientation=landscape",
    duration: "05:18",
    uploadedAt: "2026-10-16",
    uploader: "边线视角",
    views: 39120,
    episode: "第127期",
    level: "顶级",
    region: "国内",
    timeRange: "本周",
    tags: ["乌龙球", "补时", "解围失误"],
    description:
      "全场第 94 分钟，一脚本应踢向边线的解围却钻进了自家球门死角。三分解变一分，主队替补席集体愣住。",
    notes:
      "慢镜头显示解围瞬间支撑脚打滑，触球部位从脚背变成脚内侧。守门员已经提前向近角移动，对这脚变线毫无办法。",
  },
  {
    id: "v-103",
    title: "禁区假摔两次吃牌：VAR 介入后的尴尬三分钟",
    categoryId: "football",
    cover:
      "https://readdy.ai/api/search-image?query=Referee%20reviewing%20a%20pitchside%20monitor%20in%20a%20rainy%20football%20stadium%2C%20cool%20navy%20tones%20with%20warm%20amber%20spotlight%2C%20cinematic%20documentary%20sports%20photography%2C%20high%20detail%2C%20shallow%20depth%20of%20field%2C%20clean%20dark%20background&width=640&height=360&seq=bl-103&orientation=landscape",
    duration: "06:05",
    uploadedAt: "2026-10-15",
    uploader: "判罚复盘室",
    views: 28140,
    episode: "第126期",
    level: "职业",
    region: "海外",
    timeRange: "本周",
    tags: ["VAR", "假摔", "争议判罚"],
    description:
      "同一名球员在禁区内两次倒地，主裁先给点球再改判，最后出示黄牌。三分钟里场上发生了四次判罚反转。",
    notes:
      "第一次接触确有身体对抗，但接触点已在禁区外；第二次则是明显的主动找接触。VAR 介入后判罚流程完整，值得作为规则科普素材。",
  },
  {
    id: "v-104",
    title: "角球战术演练失败合集：五次机会零射正",
    categoryId: "football",
    cover:
      "https://readdy.ai/api/search-image?query=Football%20players%20crowded%20in%20the%20penalty%20box%20waiting%20for%20a%20corner%20kick%2C%20dramatic%20overhead%20floodlights%2C%20deep%20navy%20night%20palette%20with%20amber%20highlights%2C%20editorial%20sports%20photography%2C%20clean%20dark%20background%2C%20high%20detail&width=640&height=360&seq=bl-104&orientation=landscape",
    duration: "04:36",
    uploadedAt: "2026-10-12",
    uploader: "战术板",
    views: 19420,
    episode: "第123期",
    level: "职业",
    region: "国内",
    timeRange: "本月",
    tags: ["角球", "定位球", "战术失误"],
    description:
      "一场比赛拿到五次角球，全部按同一套战术执行，结果零射正。我们把五个角球的落点标了出来。",
    notes:
      "五次角球的第一落点全部落在小禁区线外一米，恰好是对手高中卫的控制区。缺少近点干扰是这套战术最大的问题。",
  },
  {
    id: "v-105",
    title: "门线悬案回看：皮球到底过线了吗",
    categoryId: "football",
    cover:
      "https://readdy.ai/api/search-image?query=Close%20up%20of%20a%20football%20rolling%20on%20the%20goal%20line%20with%20a%20goalkeeper%20reaching%20late%2C%20dark%20stadium%20background%2C%20cool%20navy%20shade%20with%20golden%20floodlight%20glow%2C%20cinematic%20sports%20photography%2C%20high%20detail%2C%20shallow%20focus%2C%20professional%20broadcast%20look&width=640&height=360&seq=bl-105&orientation=landscape",
    duration: "07:12",
    uploadedAt: "2026-10-08",
    uploader: "门线技术组",
    views: 33250,
    episode: "第119期",
    level: "顶级",
    region: "海外",
    timeRange: "本月",
    tags: ["门线技术", "争议判罚", "关键回合"],
    description:
      "一记贴地射门在门线上被捞出，主裁没有判进球。三个角度的慢放给出了完全不同的观感。",
    notes:
      "从底线机位看皮球整体似乎已越线，但从高机位看仍有一丝压在线上。没有门线技术的球场只能依赖主裁判断，这也是赛后争议的根源。",
  },
  {
    id: "v-106",
    title: "经典回顾：那场 0:7 之后，教练席上的三分钟空白",
    categoryId: "football",
    cover:
      "https://readdy.ai/api/search-image?query=Empty%20football%20coach%20dugout%20with%20a%20tactical%20board%20after%20a%20heavy%20defeat%2C%20dim%20navy%20stadium%20lighting%20with%20warm%20amber%20edge%20glow%2C%20cinematic%20editorial%20photography%2C%20melancholic%20mood%2C%20clean%20dark%20background%2C%20high%20detail&width=640&height=360&seq=bl-106&orientation=landscape",
    duration: "12:30",
    uploadedAt: "2026-09-21",
    uploader: "经典档案室",
    views: 61080,
    episode: "经典档案",
    level: "顶级",
    region: "海外",
    timeRange: "经典",
    tags: ["惨败", "经典回顾", "教练席"],
    description:
      "一场 0:7 的惨败之后，镜头在教练席上停留了整整三分钟。没有换人，没有喊话，只有不断翻动的战术板。",
    notes:
      "这场比赛被认为是那支球队重建的起点。赛后发布会上教练只说了一句话：我们需要重新学习怎么防守。三年后他们拿到了联赛冠军。",
  },
  {
    id: "v-201",
    title: "第57期｜空篮不进的五种方式，最后一种连队友都笑了",
    categoryId: "basketball",
    cover:
      "https://readdy.ai/api/search-image?query=Basketball%20player%20missing%20an%20open%20layup%20under%20bright%20arena%20lights%2C%20deep%20navy%20shadows%20with%20amber%20rim%20lighting%2C%20cinematic%20sports%20photography%2C%20high%20detail%2C%20energetic%20mood%2C%20clean%20dark%20background%2C%20editorial%20style&width=640&height=360&seq=bl-201&orientation=landscape",
    duration: "06:48",
    uploadedAt: "2026-10-17",
    uploader: "篮下视角",
    views: 45320,
    episode: "第57期",
    level: "顶级",
    region: "国内",
    timeRange: "本周",
    tags: ["空篮不进", "低级失误", "名场面"],
    description:
      "从快攻上篮到篮下补篮，本期把五种最不该出现的空篮不进方式一次看完，最后一种连场边队友都忍不住笑出声。",
    notes:
      "五种情况里有三种是因为起跳前没有调整好步点，另外两种则是过于放松。职业赛场上，空篮不进的代价往往不止两分。",
  },
  {
    id: "v-202",
    title: "最后12秒领先5分被翻盘：三次发球失误全记录",
    categoryId: "basketball",
    cover:
      "https://readdy.ai/api/search-image?query=Basketball%20inbound%20pass%20being%20intercepted%20in%20the%20final%20seconds%20of%20a%20game%2C%20dramatic%20arena%20lighting%20with%20navy%20and%20amber%20tones%2C%20cinematic%20sports%20photography%2C%20high%20detail%2C%20tension%20filled%20atmosphere%2C%20clean%20dark%20background&width=640&height=360&seq=bl-202&orientation=landscape",
    duration: "05:56",
    uploadedAt: "2026-10-16",
    uploader: "关键回合",
    views: 37810,
    episode: "第56期",
    level: "职业",
    region: "国内",
    timeRange: "本周",
    tags: ["发球失误", "末节崩盘", "绝杀"],
    description:
      "最后 12 秒还领先 5 分，结果连续三次边线发球被断，对手用两个三分把比赛拖进加时并带走胜利。",
    notes:
      "三次发球都选择了同一侧，且没有设置任何掩护。对手在第二次之后就提前站好了位置，第三次抢断几乎是预判完成的。",
  },
  {
    id: "v-203",
    title: "扣篮大赛预赛现场：篮筐被扣歪，比赛中断八分钟",
    categoryId: "basketball",
    cover:
      "https://readdy.ai/api/search-image?query=Basketball%20hoop%20tilted%20after%20a%20powerful%20dunk%2C%20spotlight%20arena%20with%20dark%20navy%20backdrop%20and%20amber%20glow%2C%20cinematic%20sports%20photography%2C%20high%20detail%2C%20dramatic%20angle%20looking%20up%2C%20clean%20dark%20background&width=640&height=360&seq=bl-203&orientation=landscape",
    duration: "04:22",
    uploadedAt: "2026-10-14",
    uploader: "场馆侧记",
    views: 26490,
    episode: "第54期",
    level: "职业",
    region: "海外",
    timeRange: "本周",
    tags: ["扣篮", "设备事故", "比赛中断"],
    description:
      "一记双手暴扣直接把篮筐扣歪，工作人员搬来梯子维修，比赛中断八分钟，选手在场边做起了热身拉伸。",
    notes:
      "这类事故在业余与半职业赛场并不少见，通常与篮架配重不足有关。维修期间裁判给了双方各两分钟热身时间。",
  },
  {
    id: "v-204",
    title: "防守漏人集锦：底角三分空位，教练直接叫停",
    categoryId: "basketball",
    cover:
      "https://readdy.ai/api/search-image?query=Wide%20open%20corner%20three%20point%20shot%20in%20an%20empty%20basketball%20gym%2C%20moody%20navy%20lighting%20with%20warm%20amber%20accents%2C%20cinematic%20editorial%20sports%20photography%2C%20high%20detail%2C%20clean%20dark%20background%2C%20professional%20look&width=640&height=360&seq=bl-204&orientation=landscape",
    duration: "07:04",
    uploadedAt: "2026-10-10",
    uploader: "防守研究室",
    views: 15870,
    episode: "第51期",
    level: "业余",
    region: "国内",
    timeRange: "本月",
    tags: ["防守漏人", "底角三分", "战术失误"],
    description:
      "连续四个回合，底角都站着一名完全无人防守的射手。第四次命中之后，教练终于忍不住叫了暂停。",
    notes:
      "问题出在弱侧协防的轮转顺序，两名球员同时收缩内线，底角自然被放空。这不是态度问题，而是沟通没有建立起来。",
  },
  {
    id: "v-205",
    title: "经典回顾：罚球 12 中 2，这场比赛输在了最简单的得分方式",
    categoryId: "basketball",
    cover:
      "https://readdy.ai/api/search-image?query=Basketball%20player%20standing%20alone%20at%20the%20free%20throw%20line%20in%20a%20silent%20arena%2C%20deep%20navy%20shadows%20with%20a%20single%20amber%20spotlight%2C%20cinematic%20sports%20photography%2C%20high%20detail%2C%20lonely%20atmosphere%2C%20clean%20dark%20background&width=640&height=360&seq=bl-205&orientation=landscape",
    duration: "09:15",
    uploadedAt: "2026-09-18",
    uploader: "经典档案室",
    views: 52940,
    episode: "经典档案",
    level: "顶级",
    region: "海外",
    timeRange: "经典",
    tags: ["罚球", "经典回顾", "惜败"],
    description:
      "全场罚球 12 中 2，最终只输 3 分。这场比赛之后，球队把每天训练的最后 20 分钟全部改成了罚球。",
    notes:
      "数据显示该队当季罚球命中率联盟垫底，但这场比赛的极端表现仍属罕见。教练赛后主动承担了责任，认为训练安排有问题。",
  },
  {
    id: "v-301",
    title: "第94期｜闪现空放三次，这波团战到底谁在指挥",
    categoryId: "esports",
    cover:
      "https://readdy.ai/api/search-image?query=Esports%20arena%20stage%20with%20players%20at%20computer%20stations%20and%20glowing%20screens%2C%20dark%20navy%20hall%20with%20warm%20amber%20stage%20lighting%2C%20cinematic%20editorial%20photography%2C%20high%20detail%2C%20focused%20tense%20atmosphere%2C%20clean%20dark%20background&width=640&height=360&seq=bl-301&orientation=landscape",
    duration: "10:26",
    uploadedAt: "2026-10-17",
    uploader: "团战复盘组",
    views: 41260,
    episode: "第94期",
    level: "职业",
    region: "国内",
    timeRange: "本周",
    tags: ["团战失误", "闪现空放", "指挥问题"],
    description:
      "关键团战里闪现连空三次，队友跟不上输出，一波被打成 0 换 4。我们把语音时间轴和画面同步放在了同一屏。",
    notes:
      "三次闪现都发生在技能读条将要结束的瞬间，属于典型的操作紧张。更值得注意的是队伍在开团前没有统一目标，沟通出现了明显分歧。",
  },
  {
    id: "v-302",
    title: "大龙争夺战：打野抢龙失败，五人被一波带走",
    categoryId: "esports",
    cover:
      "https://readdy.ai/api/search-image?query=Esports%20players%20in%20headsets%20reacting%20to%20a%20lost%20objective%2C%20moody%20dark%20navy%20room%20with%20amber%20monitor%20glow%2C%20cinematic%20documentary%20photography%2C%20high%20detail%2C%20dramatic%20expression%2C%20clean%20dark%20background&width=640&height=360&seq=bl-302&orientation=landscape",
    duration: "08:03",
    uploadedAt: "2026-10-15",
    uploader: "野区观察",
    views: 35680,
    episode: "第92期",
    level: "顶级",
    region: "海外",
    timeRange: "本周",
    tags: ["抢龙", "团灭", "决策失误"],
    description:
      "残血打野坚持抢龙，惩戒交早半秒，对手拿下大龙后直接推进，五人被团灭收场。",
    notes:
      "按当时的经济差，放弃大龙换一座二塔是更优选择。队伍选择了风险最高的一条路，也承担了最坏的结果。",
  },
  {
    id: "v-303",
    title: "解说席沉默的十秒：一波 0 换 5 的翻盘起点",
    categoryId: "esports",
    cover:
      "https://readdy.ai/api/search-image?query=Empty%20esports%20commentator%20desk%20with%20headsets%20and%20microphones%20after%20a%20shocking%20moment%2C%20dim%20navy%20hall%20with%20amber%20backlight%2C%20cinematic%20editorial%20photography%2C%20high%20detail%2C%20quiet%20dramatic%20mood%2C%20clean%20dark%20background&width=640&height=360&seq=bl-303&orientation=landscape",
    duration: "07:31",
    uploadedAt: "2026-10-13",
    uploader: "赛场音轨",
    views: 29840,
    episode: "第90期",
    level: "顶级",
    region: "国内",
    timeRange: "本月",
    tags: ["团灭", "解说沉默", "翻盘"],
    description:
      "落后一万经济的一方在野区发起团战，结果打出一波 0 换 5。解说席沉默了整整十秒，然后才开始复盘。",
    notes:
      "这波团战的转折点是对方双C走位重叠，被一个范围技能同时命中。此后的十二分钟里，比赛彻底反转。",
  },
  {
    id: "v-304",
    title: "选手操作慢放：按键失误导致关键技能全空",
    categoryId: "esports",
    cover:
      "https://readdy.ai/api/search-image?query=Close%20up%20of%20an%20esports%20player%20hands%20on%20a%20keyboard%20and%20mouse%20under%20amber%20light%2C%20dark%20navy%20background%2C%20cinematic%20product%20style%20photography%2C%20high%20detail%2C%20shallow%20depth%20of%20field%2C%20moody%20professional%20look&width=640&height=360&seq=bl-304&orientation=landscape",
    duration: "06:14",
    uploadedAt: "2026-10-09",
    uploader: "操作细节",
    views: 18220,
    episode: "第86期",
    level: "职业",
    region: "海外",
    timeRange: "本月",
    tags: ["操作失误", "慢放", "关键技能"],
    description:
      "把画面放慢到 0.25 倍之后，能看到技能全部打空的原因：按键顺序错了一格，整套连招从第一下就崩了。",
    notes:
      "这种失误在高压局面下并不罕见，选手本人赛后也表示当时过于着急。慢放视频对理解操作细节很有帮助。",
  },
  {
    id: "v-305",
    title: "经典回顾：三路高地被推平前的最后一波集火",
    categoryId: "esports",
    cover:
      "https://readdy.ai/api/search-image?query=Esports%20team%20celebrating%20a%20comeback%20win%20on%20stage%20with%20amber%20confetti%20light%2C%20dark%20navy%20arena%20background%2C%20cinematic%20editorial%20photography%2C%20high%20detail%2C%20energetic%20atmosphere%2C%20clean%20dark%20background&width=640&height=360&seq=bl-305&orientation=landscape",
    duration: "14:02",
    uploadedAt: "2026-09-25",
    uploader: "经典档案室",
    views: 47600,
    episode: "经典档案",
    level: "顶级",
    region: "海外",
    timeRange: "经典",
    tags: ["经典回顾", "逆风翻盘", "集火"],
    description:
      "三路高地全破的情况下，一次精准的四保一集火把对手核心秒掉，随后一路推进完成翻盘。",
    notes:
      "这波团战被认为是当季最精彩的防守反击。队伍在视野全面落后的情况下，靠一次预判开团把局势拉了回来。",
  },
  {
    id: "v-401",
    title: "第41期｜进站换胎三秒变十三秒，冠军直接丢掉",
    categoryId: "racing",
    cover:
      "https://readdy.ai/api/search-image?query=Race%20car%20pit%20stop%20with%20mechanics%20struggling%20with%20a%20wheel%20gun%20at%20night%2C%20dark%20navy%20pit%20lane%20with%20warm%20amber%20work%20lights%2C%20cinematic%20sports%20photography%2C%20high%20detail%2C%20tense%20action%2C%20clean%20dark%20background&width=640&height=360&seq=bl-401&orientation=landscape",
    duration: "05:40",
    uploadedAt: "2026-10-16",
    uploader: "维修区记录",
    views: 32480,
    episode: "第41期",
    level: "顶级",
    region: "海外",
    timeRange: "本周",
    tags: ["进站失误", "换胎", "丢冠"],
    description:
      "一次本该三秒完成的进站拖到了十三秒，右后轮螺母卡死，车手从领跑直接掉到第五。",
    notes:
      "回放显示螺母在装配时就已经出现轻微倾斜，属于典型的操作衔接问题。这次失误让车队失去了年度积分榜的关键位置。",
  },
  {
    id: "v-402",
    title: "最后一圈打滑出界：轮胎温度管理失败全过程",
    categoryId: "racing",
    cover:
      "https://readdy.ai/api/search-image?query=Race%20car%20spinning%20off%20track%20with%20smoke%20from%20the%20tyres%20at%20night%2C%20dark%20navy%20asphalt%20with%20amber%20floodlight%20streaks%2C%20cinematic%20motorsport%20photography%2C%20high%20detail%2C%20motion%20blur%2C%20dramatic%20mood&width=640&height=360&seq=bl-402&orientation=landscape",
    duration: "06:28",
    uploadedAt: "2026-10-11",
    uploader: "弯道视角",
    views: 24160,
    episode: "第38期",
    level: "职业",
    region: "海外",
    timeRange: "本月",
    tags: ["打滑", "轮胎管理", "最后一圈"],
    description:
      "最后一圈还在争第二，出弯时后轮突然失去抓地力，赛车横着滑出赛道，积分就此归零。",
    notes:
      "车队无线电记录显示，工程师在倒数第三圈就提醒过轮胎温度过高。车手选择了继续推进，最终付出了代价。",
  },
  {
    id: "v-403",
    title: "发车阶段三车连环追尾，赛道短暂封闭",
    categoryId: "racing",
    cover:
      "https://readdy.ai/api/search-image?query=Motorsport%20starting%20grid%20with%20several%20cars%20bunched%20together%20after%20a%20collision%2C%20night%20race%20with%20navy%20sky%20and%20amber%20track%20lights%2C%20cinematic%20sports%20photography%2C%20high%20detail%2C%20dramatic%20wide%20angle%2C%20clean%20dark%20background&width=640&height=360&seq=bl-403&orientation=landscape",
    duration: "04:52",
    uploadedAt: "2026-10-05",
    uploader: "赛道解说",
    views: 21630,
    episode: "第33期",
    level: "职业",
    region: "国内",
    timeRange: "本月",
    tags: ["连环追尾", "发车", "赛道封闭"],
    description:
      "发车第一弯三台赛车挤在同一条线上，最外侧的车被顶出赛道，连环碰撞后赛道封闭了六分钟。",
    notes:
      "起步阶段的判断空间极小，第一弯的拥挤几乎是必然。赛会判定为比赛事故，没有追加处罚。",
  },
  {
    id: "v-404",
    title: "经典回顾：维修区超速罚停，从第一掉到第十一",
    categoryId: "racing",
    cover:
      "https://readdy.ai/api/search-image?query=Race%20car%20driving%20through%20a%20dimly%20lit%20pit%20lane%20at%20night%2C%20long%20exposure%20light%20streaks%20in%20amber%2C%20deep%20navy%20shadows%2C%20cinematic%20motorsport%20photography%2C%20high%20detail%2C%20clean%20dark%20background&width=640&height=360&seq=bl-404&orientation=landscape",
    duration: "08:47",
    uploadedAt: "2026-09-14",
    uploader: "经典档案室",
    views: 38920,
    episode: "经典档案",
    level: "顶级",
    region: "海外",
    timeRange: "经典",
    tags: ["经典回顾", "超速罚停", "名次大跌"],
    description:
      "因为维修区超速被罚停十秒，原本领先的车手出站后掉到第十一，整场比赛再也没能回到前三。",
    notes:
      "限速器按钮在进站前两秒才被按下，此时车速仍高于限制值。这类失误在当年的技术条件下发生过多起。",
  },
  {
    id: "v-501",
    title: "第23期｜接力赛交棒失误：三次掉棒直接无缘决赛",
    categoryId: "general",
    cover:
      "https://readdy.ai/api/search-image?query=Track%20and%20field%20relay%20runners%20dropping%20the%20baton%20in%20the%20exchange%20zone%2C%20night%20stadium%20with%20navy%20shadows%20and%20amber%20floodlights%2C%20cinematic%20sports%20photography%2C%20high%20detail%2C%20dynamic%20motion%2C%20clean%20dark%20background&width=640&height=360&seq=bl-501&orientation=landscape",
    duration: "05:12",
    uploadedAt: "2026-10-17",
    uploader: "田径观察",
    views: 27350,
    episode: "第23期",
    level: "职业",
    region: "国内",
    timeRange: "本周",
    tags: ["接力", "掉棒", "交棒失误"],
    description:
      "预赛三次交棒全部出现失误，其中两次直接掉棒。原本有实力进决赛的队伍止步小组第五。",
    notes:
      "三次失误都发生在交棒区的最后两米，说明启动时机偏早。接力项目的节奏训练远比个人能力更重要。",
  },
  {
    id: "v-502",
    title: "网球抢七局连续双误，赛点上的一记下网",
    categoryId: "general",
    cover:
      "https://readdy.ai/api/search-image?query=Tennis%20player%20serving%20under%20bright%20night%20court%20lights%20with%20a%20dark%20navy%20crowd%20background%2C%20warm%20amber%20accents%2C%20cinematic%20sports%20photography%2C%20high%20detail%2C%20focused%20tension%2C%20clean%20dark%20background&width=640&height=360&seq=bl-502&orientation=landscape",
    duration: "07:56",
    uploadedAt: "2026-10-13",
    uploader: "底线视角",
    views: 23810,
    episode: "第20期",
    level: "顶级",
    region: "海外",
    timeRange: "本周",
    tags: ["双误", "抢七", "赛点"],
    description:
      "抢七局 5:3 领先时连续两个双误，随后一记正手下网送出赛点。整盘比赛只用了九分钟就被逆转。",
    notes:
      "数据统计显示该球员二发平均时速比平时低了 15 公里，明显受到心理影响。赛点上的那一记下网也印证了动作变形。",
  },
  {
    id: "v-503",
    title: "跳远犯规合集：三跳全部踩线，成绩清零",
    categoryId: "general",
    cover:
      "https://readdy.ai/api/search-image?query=Long%20jump%20takeoff%20board%20with%20sand%20pit%20in%20a%20night%20stadium%2C%20deep%20navy%20shadows%20with%20amber%20stadium%20lighting%2C%20cinematic%20editorial%20sports%20photography%2C%20high%20detail%2C%20clean%20dark%20background%2C%20dramatic%20angle&width=640&height=360&seq=bl-503&orientation=landscape",
    duration: "04:08",
    uploadedAt: "2026-10-07",
    uploader: "赛场边角",
    views: 12470,
    episode: "第16期",
    level: "业余",
    region: "国内",
    timeRange: "本月",
    tags: ["跳远", "踩线", "犯规"],
    description:
      "三跳全部踩线，成绩直接清零。第三跳只超出两厘米，慢镜头里几乎看不出来。",
    notes:
      "踩线问题通常来自助跑节奏不稳定。三跳的起跳点一次比一次靠前，说明选手在刻意找感觉，但适得其反。",
  },
  {
    id: "v-504",
    title: "经典回顾：马拉松终点前一百米抽筋倒地",
    categoryId: "general",
    cover:
      "https://readdy.ai/api/search-image?query=Marathon%20runner%20collapsing%20near%20the%20finish%20line%20at%20night%2C%20city%20lights%20bokeh%20in%20navy%20tones%20with%20amber%20glow%2C%20cinematic%20documentary%20sports%20photography%2C%20high%20detail%2C%20emotional%20atmosphere%2C%20clean%20dark%20background&width=640&height=360&seq=bl-504&orientation=landscape",
    duration: "09:38",
    uploadedAt: "2026-09-30",
    uploader: "经典档案室",
    views: 30180,
    episode: "经典档案",
    level: "职业",
    region: "海外",
    timeRange: "经典",
    tags: ["马拉松", "抽筋", "经典回顾"],
    description:
      "终点前一百米小腿抽筋倒地，志愿者上前搀扶，他坚持爬起来走完了最后几十米。",
    notes:
      "这场比赛他没有拿到名次，但完赛画面成了当年传播最广的镜头之一。赛后检查确认是电解质失衡引起的痉挛。",
  },
];

export interface HeroSlide {
  videoId: string;
  image: string;
  kicker: string;
  headline: string;
}

export const heroSlides: HeroSlide[] = [
  {
    videoId: "v-101",
    image:
      "https://readdy.ai/api/search-image?query=Dramatic%20wide%20view%20of%20a%20floodlit%20football%20stadium%20at%20night%20with%20deep%20navy%20shadows%20and%20warm%20amber%20light%20beams%20cutting%20through%20mist%2C%20empty%20pitch%20with%20dramatic%20contrast%2C%20cinematic%20editorial%20sports%20photography%2C%20high%20detail%2C%20moody%20atmosphere%2C%20ultra%20wide%20composition&width=1600&height=900&seq=bl-hero-01&orientation=landscape",
    kicker: "今日黑榜 · 第128期",
    headline: "门将三连脱手，防线集体走神",
  },
  {
    videoId: "v-201",
    image:
      "https://readdy.ai/api/search-image?query=Empty%20basketball%20arena%20at%20night%20seen%20from%20the%20upper%20stands%2C%20polished%20court%20reflecting%20amber%20spotlights%2C%20deep%20navy%20surroundings%2C%20cinematic%20editorial%20sports%20photography%2C%20high%20detail%2C%20dramatic%20shadows%2C%20ultra%20wide%20composition&width=1600&height=900&seq=bl-hero-02&orientation=landscape",
    kicker: "今日更新 · 篮球",
    headline: "空篮不进的五种方式",
  },
  {
    videoId: "v-301",
    image:
      "https://readdy.ai/api/search-image?query=Wide%20shot%20of%20an%20esports%20arena%20stage%20with%20glowing%20screens%20and%20a%20silhouetted%20crowd%2C%20dark%20navy%20hall%20with%20warm%20amber%20stage%20beams%2C%20cinematic%20editorial%20photography%2C%20high%20detail%2C%20futuristic%20mood%2C%20ultra%20wide%20composition&width=1600&height=900&seq=bl-hero-03&orientation=landscape",
    kicker: "热搜团战 · 电竞",
    headline: "闪现空放三次，谁在指挥",
  },
  {
    videoId: "v-401",
    image:
      "https://readdy.ai/api/search-image?query=Night%20racing%20circuit%20with%20long%20exposure%20light%20trails%20in%20amber%20and%20white%2C%20dark%20navy%20asphalt%20and%20grandstands%2C%20cinematic%20motorsport%20photography%2C%20high%20detail%2C%20dramatic%20contrast%2C%20ultra%20wide%20composition%2C%20professional%20editorial%20look&width=1600&height=900&seq=bl-hero-04&orientation=landscape",
    kicker: "维修区事故 · 赛车",
    headline: "换胎三秒变十三秒，冠军丢了",
  },
];

export const editorialNotes = [
  {
    tag: "观察",
    title: "为什么“黑榜”值得被认真记录",
    text: "失误是比赛的另一半叙事。把每日赛场上的关键失误按类型归档，能让观众看清战术执行与心理波动的真实轨迹。",
  },
  {
    tag: "方法",
    title: "我们如何筛选每日条目",
    text: "每条视频至少满足一个条件：直接影响比分、包含可复盘的战术细节、或具备规则讨论价值。纯情绪化剪辑不会收录。",
  },
  {
    tag: "说明",
    title: "关于播放与版权",
    text: "站内所有封面与播放界面均为演示内容，用于呈现浏览与分类体验，不代表真实赛事画面，也不提供任何赛事直播。",
  },
];